import { List } from "immutable";
import actionTypes from "../action-types";
import CourseEnrollment from "../models/CourseEnrollment";

type Enrollments = List<CourseEnrollment>;

export default function courseEnrollmentsReducer(
  enrollments: Enrollments = List(),
  action: any
) {
  switch (action.type) {
    case actionTypes.RECEIVE_COURSE_ENROLLMENTS:
      return List<CourseEnrollment>(
        action.payload.enrollments.map((e: any) => new CourseEnrollment(e))
      );

    case actionTypes.SAVE_NEW_COURSE_ENROLLMENT:
      return enrollments.push(new CourseEnrollment(action.payload.enrollment));

    case actionTypes.DELETE_COURSE_ENROLLMENT:
      return enrollments.filter(
        (enrollment: any) => enrollment.courseId !== action.payload.courseId
      );

    default:
      return enrollments;
  }
}
